/**
 * @generated SignedSource<<5da102c59037321bd871f8de3e3df893>>
 * @relayHash 970f22796149c3daa096070747ce4257
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 371c73f96934842a4e2a0f4a232565ea37e22c5679931494e6a298483c7450c2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  entityAriApps: string;
  entityAriFilters: string;
  entityAriPlans: string;
  entityAriRoadmaps?: string | null;
  isAnonymous: boolean;
  isAppsExpanded?: boolean | null;
  isFiltersExpanded?: boolean | null;
  isOperationsExpanded?: boolean | null;
  isPlansExpanded?: boolean | null;
  isProjectsExpanded?: boolean | null;
  isRoadmapUpsellEnabled: boolean;
  ownerAri?: string | null;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenuItems">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider: {
    readonly get: () => boolean;
  };
});

import isActionMenuWithAddPeopleSpotlightIdEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider';
import isSubspaceEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider';
import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';
import isAllowingEndUsersToAccessCustomTemplates_provider from '@jira/platform__graphql-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';
import checkForA11YEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriApps"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriPlans"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriRoadmaps"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isFiltersExpanded"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOperationsExpanded"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRoadmapUpsellEnabled"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v13 = {
  "kind": "ScalarField",
  "name": "menuId"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "label"
},
v20 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v21 = {
  "kind": "ScalarField",
  "name": "url"
},
v22 = {
  "order": "DESC"
},
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v24 = {
  "kind": "ScalarField",
  "name": "title"
},
v25 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v26 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v14/*: any*/)
  ]
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v28 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "collectionId"
          },
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "emoji"
          },
          (v26/*: any*/)
        ],
        "type": "JiraProductDiscoveryCollection"
      },
      (v27/*: any*/)
    ]
  }
],
v29 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v30 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v31 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v32 = {
  "kind": "ScalarField",
  "name": "status"
},
v33 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v34 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "name"
},
v36 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v37 = [
  (v21/*: any*/)
],
v38 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v27/*: any*/)
  ]
},
v39 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v40 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v41 = {
  "kind": "ScalarField",
  "name": "softwareBoardCount"
},
v42 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v43 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": "subspaceCount",
          "kind": "ScalarField",
          "name": "subspaceCount_cse"
        }
      ]
    }
  ]
},
v44 = [
  (v14/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v25/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v43/*: any*/)
],
v45 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v44/*: any*/)
    }
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v14/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v48 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v49 = [
  {
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": [
      {
        "concreteType": "SettingsMenuItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "name": "visible"
          }
        ]
      }
    ]
  },
  (v14/*: any*/)
],
v50 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          (v26/*: any*/),
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v14/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v37/*: any*/),
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v27/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v27/*: any*/)
    ]
  }
],
v51 = [
  (v14/*: any*/),
  (v35/*: any*/),
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItems"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v12/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
      }
    ],
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudID",
                    "variableName": "cloudId"
                  },
                  {
                    "kind": "Literal",
                    "name": "navKey",
                    "value": "NAV_SIDEBAR"
                  }
                ],
                "concreteType": "JiraUserNavigationConfiguration",
                "kind": "LinkedField",
                "name": "userNavigationConfiguration",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigurableNavigationItem",
                    "kind": "LinkedField",
                    "name": "navItems",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isVisible"
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsProjectsExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "alias": "canCreateProject",
                "args": [
                  (v15/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_PROJECT"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "shouldDisplay",
                    "args": [
                      (v15/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ]
              },
              {
                "condition": "isFiltersExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsFiltersExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "globalAppNavigationItems",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v20/*: any*/),
                                  {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": true,
                                        "selections": [
                                          (v19/*: any*/),
                                          (v21/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "settingsUrl"
                                  },
                                  (v21/*: any*/)
                                ],
                                "type": "JiraAppNavigationItem"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "roadmapFavourites",
                "args": [
                  (v15/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v22/*: any*/),
                      "type": "JPD_COLLECTION"
                    }
                  },
                  (v23/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v28/*: any*/)
                  },
                  (v29/*: any*/)
                ]
              },
              {
                "alias": "roadmapRecents",
                "args": [
                  (v15/*: any*/),
                  (v30/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "JPD_COLLECTION"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v28/*: any*/)
                  },
                  (v29/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isPlansExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsPlansExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "args": (v16/*: any*/),
                "concreteType": "JiraAdvancedRoadmapsNavigation",
                "kind": "LinkedField",
                "name": "advancedRoadmapsNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasEditPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasCreateSamplePlanPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasGlobalPlansAdminPermissions"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "JiraWorkManagementLicensing",
                    "kind": "LinkedField",
                    "name": "jwmLicensing",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "currentUserSeatEdition"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v16/*: any*/),
                "concreteType": "JiraProjectsSidebarMenu",
                "kind": "LinkedField",
                "name": "jira_projectsSidebarMenu",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecent",
                    "plural": false,
                    "selections": (v44/*: any*/)
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecentFromHistory",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v31/*: any*/),
                      (v25/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      (v23/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v45/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": "favourites(first:15)"
                  },
                  {
                    "args": [
                      (v30/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "recents",
                    "plural": false,
                    "selections": [
                      (v45/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": "recents(first:20)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "favouriteLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "recentLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayMode"
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouriteFilters",
                    "args": [
                      (v15/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v22/*: any*/),
                          "type": "FILTER"
                        }
                      },
                      (v23/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  (v46/*: any*/),
                                  (v35/*: any*/),
                                  (v25/*: any*/),
                                  (v47/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              },
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentFilters",
                    "args": [
                      (v15/*: any*/),
                      (v30/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "FILTER"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v46/*: any*/),
                                  (v14/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v25/*: any*/),
                                      (v47/*: any*/)
                                    ],
                                    "type": "JiraFilter",
                                    "abstractKey": "__isJiraFilter"
                                  }
                                ],
                                "type": "JiraCustomFilter"
                              },
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "JiraSystemFilterConnection",
                    "kind": "LinkedField",
                    "name": "systemFilters",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSystemFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSystemFilter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v46/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v18/*: any*/),
                                  (v25/*: any*/),
                                  (v47/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "filtersOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriFilters"
                  },
                  (v48/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v49/*: any*/)
              }
            ]
          },
          {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouritePlans",
                    "args": [
                      (v15/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v22/*: any*/),
                          "type": "PLAN"
                        }
                      },
                      (v23/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v50/*: any*/)
                      },
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentPlans",
                    "args": [
                      (v15/*: any*/),
                      (v30/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "PLAN"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v50/*: any*/)
                      },
                      (v29/*: any*/)
                    ]
                  }
                ]
              },
              {
                "alias": "plansOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriPlans"
                  },
                  (v48/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v49/*: any*/)
              }
            ]
          },
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "appsOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriApps"
                  },
                  (v48/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v49/*: any*/)
              }
            ]
          },
          {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "OpsgenieQuery",
                "kind": "LinkedField",
                "name": "opsgenie",
                "plural": false,
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "OpsgenieSavedSearches",
                    "kind": "LinkedField",
                    "name": "savedSearches",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "starred",
                        "plural": true,
                        "selections": (v51/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "sharedWithMe",
                        "plural": true,
                        "selections": (v51/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "createdByMe",
                        "plural": true,
                        "selections": (v51/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "roadmapsOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriRoadmaps"
                  },
                  (v48/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v49/*: any*/)
              }
            ]
          },
          {
            "condition": "isRoadmapUpsellEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "ownerAri"
                      },
                      (v15/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "propertyKey",
                        "value": "jpd-roadmaps-upsell.dismissed"
                      }
                    ],
                    "concreteType": "JiraEntityPropertyString",
                    "kind": "LinkedField",
                    "name": "stringUserProperty",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "stringValue"
                      },
                      (v14/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "371c73f96934842a4e2a0f4a232565ea37e22c5679931494e6a298483c7450c2",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
    }
  }
};
})();

(node as any).hash = "aee78ecbeb949c9d5475f3964d54649e";

export default node;
